import Video from "./video/video";
import UtilityService from "../services/utility.service";
import {format} from "date-fns";
import {useEffect, useState} from "react";
import GeoLocation from "./geoLocation/geoLocation";

const MarkerInfo = (
    {
        tripId = '', alert,
        preventClicks = () => {
        },
        handleMarkerClick = (alert) => {
        },
        onAlertVideoClick = (val, videoData, alertData) => {
        },
        selectedAlert = {},
        hideInfoOnMapClick
    }
) => {


    const [showInfo, setShowInfo] = useState(false);
    const [videoData, setVideoData] = useState({});
    const [hideInfoFromMapClick, setHideInfoFromMapClick] = useState(hideInfoOnMapClick);

    const handleVideoLoaded = (video) => {
        setVideoData(video);
    }
    const handleShowInfo = () => {
        handleMarkerClick(alert);
        setShowInfo((prevState) => {
            return !prevState
        });
        setHideInfoFromMapClick(false);
    }

    const onMarkerClick = () => {

    }

    const handleVideoClick = () => {
        onAlertVideoClick(true, videoData, alert);
    }

    useEffect(() => {
        if (alert?.externalAlertId !== selectedAlert?.externalAlertId) {
            setShowInfo(false);
        }
    }, [selectedAlert]);

    useEffect(() => {
        setHideInfoFromMapClick(hideInfoOnMapClick);
        if (hideInfoOnMapClick) {
            setShowInfo(false);
        }
    }, [hideInfoOnMapClick]);

    return (
        <div className={'custom-marker-box'} onClick={preventClicks}>
            {/*<div className="font-26">{showInfo | String}{alert?.externalAlertId === selectedAlert?.externalAlertId | String}{hideInfoFromMapClick | String}</div>*/}
            <div
                className={`custom-marker ${alert.alertType} ${alert?.externalAlertId === selectedAlert?.externalAlertId ? 'active' : ''}`}
                onClick={handleShowInfo}></div>

            <div className={`marker-info-content 
                ${(showInfo && (alert?.externalAlertId === selectedAlert?.externalAlertId) && !hideInfoFromMapClick) ? 'active' : ''}`}>
                <div className={'video-container'}>
                    {alert?.isVideoAvailable && <Video tripId={tripId}
                                                       videoId={alert?.externalAlertId}
                                                       onLoaded={handleVideoLoaded} onClick={handleVideoClick}/>}
                    {!alert?.isVideoAvailable &&
                        <div className={'video flex hr-center vr-center'}>
                            <div className="error-color">Video is not available</div>
                        </div>
                    }
                </div>

                <div className="sf-medium font-13 margin-t-5">
                    <div className={`rating-box margin-b-5 ${alert?.alertType}`}>
                        {UtilityService.getAlertName(alert?.alertType)}
                    </div>
                    <ul className="separator gap-15 margin-b-5">
                        <li>{(alert.speed)?.toFixed(1)}km/h</li>
                        <li>{format(new Date(`${alert?.timestampInISO}`), 'HH:mm')}</li>
                        <li>{format(new Date(`${alert?.timestampInISO}`), 'do MMM yyyy')}</li>
                    </ul>

                    <div className="grey-color">
                        <GeoLocation lat={alert?.location?.coordinates[1]} lng={alert?.location?.coordinates[0]}/>
                    </div>
                </div>
            </div>
        </div>

    )
}


export default MarkerInfo;
